module.exports = __WEBPACK_EXTERNAL_MODULE_bootstrap_slider__;